export type TsvTableIdentity = {
  id: string | null;
  compareId: string | null;
};

const HEADER_KEYWORDS = new Set(["TABLE", "ID", "COMPARE ID", "RULESET"]);

/**
 * Reads table ID and COMPARE ID from TSV header keyword rows.
 * Stops at the property-name row (first non-keyword, non-empty first cell).
 */
export function parseTsvTableIdentity(text: string): TsvTableIdentity {
  let id: string | null = null;
  let compareId: string | null = null;

  const lines = text.split(/\r?\n/);
  for (const line of lines) {
    if (!line.trim()) continue;

    const cells = line.split("\t").map((cell) => cell.trim());
    const key = (cells[0] ?? "").toUpperCase();

    if (key === "ID") {
      id = cells[1] || null;
      continue;
    }

    if (key === "COMPARE ID") {
      compareId = cells[1] || null;
      continue;
    }

    if (key === "" || HEADER_KEYWORDS.has(key)) continue;

    break;
  }

  return { id, compareId };
}
